<template>
  <div v-if="this.deals.length != 0">
    <table class="table table-sm table-hover">
      <thead>
        <th class="text-center">Deal #</th>
        <th class="text-left">Deal Name</th>
        <th class="text-right">Issue Date </th>
        <th class="text-right">Maturity Date</th>
        <th class="text-right">Original Balance</th>
        <th class="text-right">Current Balance</th>
        <th class="text-right">Deal Factor</th>
        <th class="text-right">Factor Date</th>
      </thead>
      <tbody>
        <tr v-for="(deal, index) in this.deals" :key=deal.DealName+index>
          <td class="text-center">{{index + 1}}</td>
          <td class="text-left">
            <a v-if="isModal" :href="`/${path}?dealName=${deal.DealName}`">{{deal.DealName}}</a>
            <div v-else>
              <router-link :to="{path:path, query: {dealName : deal.DealName}}"
                @click.native="() => {
                  $store.commit('setBondName', '');
                  $store.commit('saveDealCashflow', {
                    collateralCashflow: [],
                    bondsCashflows: [],
                    collateralInfo: {},
                    bondsInfo: {},
                  });
                  $store.commit('saveAcisSingleResult', { AcisCashflow: [] });
                  $store.commit('saveCirtSingleResult', {
                    Yield: '',
                    Wal: '',
                    LossWindow: '',
                    WritedownPct: '',
                    FirstLossPeriod: '',
                    contractCashflow: [],
                    insurerOwnedCashflow: [],
                    LineMetrics: '',
                    PolicyInformation: ''
                  });
                }">
                {{deal.DealName}}
              </router-link>
              <router-link v-if="isOnlineDealsCreationAllowed && deal.DealId != null" :to="{path:'deal_create', query: {dealType: deal.DealType, dealId : deal.DealId}}">
                <i class="fas fa-edit"/>
              </router-link>
            </div>
          </td>
          <td class="text-right" v-if="allDataAvailable">{{deal.IssueDate}}</td>
          <td class="text-right" v-if="allDataAvailable">{{deal.MaturityDate}}</td>
          <td class="text-right" v-if="allDataAvailable">{{deal.OriginalBalance}}</td>
          <td class="text-right" v-if="allDataAvailable">{{deal.CurrentBalance}}</td>
          <td class="text-right" v-if="allDataAvailable">{{deal.DealFactor}}</td>
          <td class="text-right" v-if="allDataAvailable">{{deal.FactorDate}}</td>
          <td v-if="!allDataAvailable" colspan="6"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import service        from "../../services/HttpRequestService";
import formatter      from "../../utilities/Formatter";
import { mapGetters } from 'vuex';

export default {
  props: {
    isModal: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: ''
    },
    deals: {
      type: Array,
      default: []
    },
    allDataAvailable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'isOnlineDealsCreationAllowed'
    ])
  },
  async created() {
  }
};
</script>